<template>
  <nav class="navbar">
    <div class="logo">
      <img src="@/assets/tartoro-icon.png" alt="Tartoro" />
      <span class="logo-text">Tartoro</span>
    </div>
    <div class="language-dropdown">
      <div class="language-selector" @click="toggleDropdown">
        <span class="globe-icon">🌐</span>
        <span id="selected-language">{{ currentLanguage }}</span> ▼
      </div>
      <div class="dropdown-content" v-show="isDropdownOpen">
        <a href="#" @click.prevent="changeLanguage('en')">English</a>
        <a href="#" @click.prevent="changeLanguage('es')">Español</a>
      </div>
    </div>
  </nav>
</template>

<script>
import '@/styles/CustomerBusiness.css'

export default {
  name: 'NavBar',
  data() {
    return {
      isDropdownOpen: false,
      currentLanguage: 'Español'
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    changeLanguage(lang) {
      // Update the selected language text
      this.currentLanguage = lang === 'en' ? 'English' : 'Español';
      
      // Emit an event to parent component
      this.$emit('language-changed', lang);
      
      // Close the dropdown
      this.isDropdownOpen = false;
    }
  },
  created() {
    // Set initial language from localStorage
    const savedLanguage = localStorage.getItem('language') || 'en';
    this.currentLanguage = savedLanguage === 'en' ? 'English' : 'Español';
  }
}
</script>

<style scoped>
.language-dropdown {
  position: relative;
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: white;
  min-width: 120px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  border-radius: 4px;
  z-index: 1000;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.language-selector {
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-selector:hover {
  background-color: #f5f5f5;
}
</style> 